import { useState } from 'react'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import FormControl from '@mui/material/FormControl'
import MenuItem from '@mui/material/MenuItem'
import ClickAwayListener from '@mui/material/ClickAwayListener'
import { max } from 'lodash-es'
import styled from '@emotion/styled'
import { FunctionModal } from 'components/common/Modal'
import { ScrollableBox } from 'components/common/Modal'
import Select from 'components/common/Select'
import { CloseSVG } from 'components/common/SVGElements'

const StyledModal = styled.div`
  ${({
    theme,
    $top,
    $left,
    $right,
    $width,
    $alignRight,
    $maxWidth,
    $maxHeight,
  }) => `
    position: absolute;
    top: ${$top}px;
    left: ${$left}px;
    right: ${$right}px;
    width: ${$width}px;
    max-width: ${$maxWidth}px;
    min-height: 100px;
    max-height: ${$maxHeight}px;
    background-color: white;
    z-index: 1;
    border-radius: ${$alignRight ? '6px 0px 6px 6px' : '0px 6px 6px 6px'};
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
    border: 1px solid ${theme.palette.background.line};
    overflow: auto;
    padding: 18px 15px;
  `}
`

const calculateModalPosition = (e) => {
  const top = e.target.clientHeight - 2
  const width =
    window.innerWidth < 768
      ? Math.floor(window.innerWidth * 0.9)
      : Math.floor(window.innerWidth * 0.4)
  const maxWidth = 320
  const modalRectTop =
    e.target.getBoundingClientRect().top + e.target.clientHeight - 2
  const maxHeight = max([window.innerHeight - modalRectTop, 250])
  const modalRectLeft = e.target.getBoundingClientRect().left
  const alignRight = modalRectLeft + width > window.innerWidth
  const left = alignRight ? 'unset' : 0
  const right = alignRight ? 0 : 'unset'

  return { top, left, right, width, maxWidth, maxHeight, alignRight }
}

const PopupRadioSelect = ({
  placeholder = '',
  selectedText = '',
  modalContent,
  onOpen,
  closeModalOnInnerClick = true,
  fullWidth,
  size,
  isLarge,
  onChange,
  selectedId,
  isMobile,
}) => {
  const [desktopFilterModal, setDesktopFilterModal] = useState({ open: false })
  const [mobileFilterModal, setMobileFilterModal] = useState({ open: false })

  const handleSelectClick = (e) => {
    const modalPosition = calculateModalPosition(e)
    setDesktopFilterModal((prev) => ({ open: !prev.open, ...modalPosition }))
    if (!desktopFilterModal.open && onOpen) onOpen()
  }

  const handleModalClick = () => {
    if (closeModalOnInnerClick) {
      setTimeout(() => {
        setDesktopFilterModal({ open: false })
      }, 0)
    }
  }

  const handleMobileFilterModalClose = () =>
    setMobileFilterModal({ open: false })
  const handleMobileFilterModalConfirm = () => {
    setMobileFilterModal({ open: false })
    if (onChange) onChange(selectedId)
  }

  return (
    <ClickAwayListener
      onClickAway={() => setDesktopFilterModal({ open: false })}
    >
      <FormControl
        fullWidth={fullWidth}
        sx={{
          ...(isMobile && { display: 'contents' }),
        }}
      >
        <Select
          open={false}
          value={!!selectedText || ''}
          native={false}
          size={size}
          displayEmpty
          onClick={
            !isLarge
              ? () => setMobileFilterModal({ open: true })
              : handleSelectClick
          }
        >
          <MenuItem value="">{placeholder}</MenuItem>
          <MenuItem value={true}>{selectedText}</MenuItem>
        </Select>
        {!isLarge ? (
          <FunctionModal open={mobileFilterModal.open}>
            <Box display="flex" flexDirection="column" height="100%">
              <Box
                display="flex"
                justifyContent="center"
                p={4}
                position="relative"
              >
                <Box sx={{ position: 'absolute', left: '10px' }}>
                  <CloseSVG onClick={handleMobileFilterModalClose}></CloseSVG>
                </Box>
                <Typography variant="titleSmall">服務</Typography>
              </Box>
              <ScrollableBox flexGrow={1} mt={4} mx={4}>
                {modalContent}
              </ScrollableBox>
              <Box p={5}>
                <Grid container spacing={5}>
                  <Grid item xs={12}>
                    <Button
                      variant="contained"
                      fullWidth
                      onClick={handleMobileFilterModalConfirm}
                    >
                      送出
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            </Box>
          </FunctionModal>
        ) : (
          desktopFilterModal.open && (
            <StyledModal
              $top={desktopFilterModal.top}
              $left={desktopFilterModal.left}
              $right={desktopFilterModal.right}
              $alignRight={desktopFilterModal.alignRight}
              $width={desktopFilterModal.width}
              $maxHeight={desktopFilterModal.maxHeight}
              $maxWidth={desktopFilterModal.maxWidth}
              onClick={handleModalClick}
            >
              {modalContent}
            </StyledModal>
          )
        )}
      </FormControl>
    </ClickAwayListener>
  )
}

export default PopupRadioSelect
